import UIButton from 'UIComponents/button/UIButton';
import H7 from 'UIComponents/elements/headings/H7';
import UIIcon from 'UIComponents/icon/UIIcon';
import UISection from 'UIComponents/section/UISection';
import SingleEmailInputWithControls from './SingleEmailInputWithControls';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import emptyFunction from 'react-utils/emptyFunction';
import { useCallback } from 'react';
import PropertyInputMultiplePropertyPopoverBody from '../../PropertyInputMultiplePropertyPopoverBody';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertyInputMultipleEmailPopoverBody = ({
  accessLevel,
  additionalEmails,
  disabled,
  enablePopovers,
  inputMode,
  objectTypeId,
  onPrimaryEmailInputAdded,
  onPrimaryEmailDeleted,
  onPrimaryEmailSaved,
  onPromoteToPrimary,
  onAdditionalEmailInputAdded,
  onAdditionalEmailDeleted,
  onAdditionalEmailSaved,
  primaryEmail,
  property,
  subjectId,
  showAutoSaveText
}) => {
  const handleEmailInputCreated = useCallback(() => {
    if (!primaryEmail) {
      onPrimaryEmailInputAdded();
    } else {
      onAdditionalEmailInputAdded();
    }
  }, [onPrimaryEmailInputAdded, onAdditionalEmailInputAdded, primaryEmail]);
  return /*#__PURE__*/_jsxs(PropertyInputMultiplePropertyPopoverBody, {
    children: [/*#__PURE__*/_jsxs(UISection, {
      style: {
        width: '100%'
      },
      children: [/*#__PURE__*/_jsx(H7, {
        "data-selenium-test": "email-input-primary-heading",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.PropertyInputMultipleEmailV2.primaryEmail"
        })
      }), primaryEmail && /*#__PURE__*/_jsx(SingleEmailInputWithControls, {
        accessLevel: accessLevel,
        disabled: disabled,
        enablePopovers: enablePopovers
        // Setting a key here ensures that the editable controls around the
        // input is automatically closed when another email is promoted to
        // primary
        ,

        isNewEmail: primaryEmail.isNewEmail,
        isOnlyEmail: additionalEmails.length === 0,
        isPrimaryEmail: true,
        objectTypeId: objectTypeId,
        onDelete: onPrimaryEmailDeleted,
        onPromoteToPrimary: emptyFunction,
        onSave: onPrimaryEmailSaved,
        property: property,
        subjectId: subjectId,
        value: primaryEmail,
        showAutoSaveText: showAutoSaveText,
        inputMode: inputMode
      }, primaryEmail.id)]
    }), primaryEmail && /*#__PURE__*/_jsxs(UISection, {
      style: {
        width: '100%'
      },
      children: [/*#__PURE__*/_jsx(H7, {
        "data-selenium-test": "email-input-additional-heading",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.PropertyInputMultipleEmailV2.additionalEmails"
        })
      }), additionalEmails.map(email => /*#__PURE__*/_jsx(SingleEmailInputWithControls, {
        accessLevel: accessLevel,
        className: "m-top-4",
        disabled: disabled,
        enablePopovers: enablePopovers,
        isOnlyEmail: false,
        isNewEmail: email.isNewEmail,
        isPrimaryEmail: false,
        objectTypeId: objectTypeId,
        onDelete: onAdditionalEmailDeleted,
        onPromoteToPrimary: onPromoteToPrimary,
        onSave: onAdditionalEmailSaved,
        property: property,
        subjectId: subjectId,
        value: email,
        showAutoSaveText: showAutoSaveText,
        inputMode: inputMode
      }, email.id))]
    }), /*#__PURE__*/_jsxs(UIButton, {
      className: "p-left-0",
      disabled: disabled,
      onClick: handleEmailInputCreated,
      use: "transparent",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "add",
        size: "xxs",
        color: CALYPSO_DARK
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.PropertyInputMultipleEmailV2.addEmail"
      })]
    })]
  });
};
export default PropertyInputMultipleEmailPopoverBody;